import { contactUsEmail, contactUsTel } from "../../config/vars";
import "./styles/index.css";

interface FooterProps {
  onOpenCopyrightModal: () => void;
}

export const Footer: React.FC<FooterProps> = ({ onOpenCopyrightModal }) => {
  return (
    <footer className="footer_tag">
      <div className="footer_contact_us_con">
        <a href={"tel:" + contactUsTel} className="m_fgi_text_span">
          {contactUsTel}
        </a>{" "}
        <br />
        <a href={"mailto:" + contactUsEmail} className="m_fgi_text_span">
          {contactUsEmail}
        </a>
      </div>
      <span className="footer_com_info">
        © Общество с ограниченной ответсвенностью "АБС"
      </span>
      <span className="footer_com_info">
        2000-{new Date().getFullYear()} г. Все права защищены.
      </span>
      <span
        className="footer_com_info footer_com_info_pro"
        onClick={onOpenCopyrightModal}
      >
        Подробнее
      </span>
    </footer>
  );
};
